import type { API } from 'chessboard/api/config/types';
import { isMainLine } from 'chessboard/model/line/is-main-line';

/**
 * Create the mutateGame function.
 */
export function createMutateGame(game: API.Context['game'], api: API.Model) {
  /**
   * Mutate the game and return the mutation diff after the call.
   */
  return function mutateGame(fn: Function): API.DiffData | null {
    const before = game.moveDetails();
    const beforeResult = api.getCalculatedResult();

    const response = fn();

    if (response === null) {
      return null;
    }

    const after = game.moveDetails();
    const afterResult = api.getCalculatedResult();
    const data = api.getNodeDiffData(before, after);

    if (
      beforeResult !== afterResult &&
      /**
       * The result is only updated if the current position is on the main line.
       * This is because JCE doesn't take the line into account when calculating
       * gameOver, but for our purposes - i.e. showing the result node on the
       * move list - we do require that distinction.
       */
      isMainLine(after?.ids.line)
    ) {
      data.result = afterResult;
    }

    const { line: lineId, move: moveId } = game.ids();

    // Check JCE to see if the lines need reordering.
    data.linesReordered = lineId !== 0 && moveId === 0 && game.reorderLines();

    return data;
  };
}
